import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

interface UseTenderParamsFromUrl {
  isOnShare?: true;
}

export const useTenderParamsFromUrl = ({
  isOnShare,
}: UseTenderParamsFromUrl = {}) => {
  const { pathname } = useLocation();

  const paths = useMemo(() => pathname.split('/'), [pathname]);

  let tenderId: string | undefined;
  let rootFolderId: string | undefined;
  let currentFolderId: string | undefined;

  const isOnUnassignedTenderFolders =
    pathname.includes('/tender-folders/') && !pathname.includes('/tenders/');

  if (isOnShare) {
    tenderId = paths[2];
    rootFolderId = paths[4];
    currentFolderId = paths[6];
  } else if (isOnUnassignedTenderFolders) {
    tenderId = undefined;
    rootFolderId = paths[4];
    currentFolderId = paths[6] || paths[4];
  } else {
    tenderId = paths[4];
    rootFolderId = paths[7];
    currentFolderId = paths[9];
  }

  return {
    tenderId,
    rootFolderId,
    currentFolderId,
  };
};
